import React from "react";
import { RxCross2 } from "react-icons/rx";
export default function Modal({
  displayModal,
  setDisplayModal,
  role,
  ariaModal,
  children,
}) {
  return (
    <>
      <div
        className={`modal fade ${
          displayModal === "block"
            ? "show animate__animated animate__backInDown"
            : ""
        }`}
        tabIndex="-1"
        id="newChat"
        role={role}
        aria-modal={ariaModal}
        style={{ display: displayModal }}
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content border-0">
            <div className="modal-body p-4">{children}</div>
            <button
              className="btn bg-danger text-white btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
              data-bs-dismiss="modal"
              onClick={() => {
                document.body.classList.remove("modal-open");
                document.body.style.overflow = "";
                document.body.style.paddingRight = "";
                setDisplayModal("none");
              }}
            >
              <RxCross2 />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
